import React, { useState } from "react";
import "./Tours.css";

const agendaItems = [
  { horario: "07:00", actividad: "Salida del Hotel Barceló hacia Antigua Guatemala" },
  {
    horario: "08:30 – 10:30",
    actividad: "Opción 1: Cerro de la Cruz\nOpción 2: Tour por el Centro Histórico",
  },
  { horario: "10:30 – 11:30", actividad: "Visita exclusiva a Jade Maya" },
  { horario: "11:30 – 12:30", actividad: "Traslado a Finca San Cayetano Hotel & Restaurante" },
  { horario: "12:30 – 15:00", actividad: "Almuerzo en Finca San Cayetano Hotel y Restaurante" },
  {
    horario: "15:00 – 16:00",
    actividad: "Espacio recreativo para recorrer los alrededores y tomar fotografías",
  },
  { horario: "16:00 – 18:00", actividad: "Regreso al Hotel Barceló" },
];

const destinations = [
  {
    title: "Cerro de la Cruz",
    img: "/tours/card-cerro.jpg",
    desc: "Uno de los miradores más emblemáticos de Guatemala, desde donde podrá apreciar la ciudad colonial y el majestuoso Volcán de Agua.",
    link: "https://www.guatemala.com/guias/pasatiempos/cerro-de-la-cruz-un-destino-emblematico-de-antigua-guatemala/",
  },
  {
    title: "Centro histórico",
    img: "/tours/card-centro.jpg",
    desc: "Recorra las calles empedradas y descubra la riqueza arquitectónica y cultural de una ciudad declarada Patrimonio de la Humanidad.",
    link: "https://centrohistorico.gt/la-antigua-guatemala-santiago-de-los-caballeros/",
  },
  {
    title: "Jade Maya",
    img: "/tours/card-jade.jpg",
    desc: "Conozca la importancia del jade en la civilización maya y explore una de las colecciones más representativas del país.",
    link: "https://jademaya.com/pages/jade-museum",
  },
  {
    title: "Finca San Cayetano",
    img: "/tours/card-finca.jpg",
    desc: "Disfrute de una experiencia gastronómica rodeada de naturaleza y vistas espectaculares, en un ambiente ideal para fortalecer relaciones.",
    link: "https://sancayetano.gt/",
  },
];

function buildMailto() {
  const subject = "Reserva | Experiencia Antigua Guatemala – CLADE 2026";
  const body = [
    "Estimada Sonia Girón:",
    "",
    "Deseo reservar mi espacio para participar en la Experiencia Antigua Guatemala, que se llevará a cabo el 22 de agosto de 2026, en el marco de CLADE 2026.",
    "",
    "Comparto la información requerida para completar mi inscripción:",
    "",
    "Nombre completo: ",
    "Empresa: ",
    "Cargo: ",
    "Correo electrónico: ",
    "Teléfono: ",
    "Número de identificación o pasaporte: ",
    "Restricciones alimenticias (si aplica): ",
    "Cantidad de participantes: ",
    "",
    "Quedo atento(a) a la confirmación de mi reserva y a cualquier información adicional.",
  ].join("\n");
  return `mailto:sgiron@ebg.edu.gt?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
}

function CalendarIcon({ size = 15 }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <rect x="3" y="4" width="18" height="18" rx="2" />
      <line x1="16" y1="2" x2="16" y2="6" />
      <line x1="8" y1="2" x2="8" y2="6" />
      <line x1="3" y1="10" x2="21" y2="10" />
    </svg>
  );
}

function AccordionItem({ title, open, onToggle, children }) {
  return (
    <div className="tours-acc-item">
      <button className="tours-acc-btn" onClick={onToggle}>
        <span className="tours-acc-title">{title}</span>
        <span
          className="tours-acc-chevron"
          style={{ transform: open ? "rotate(180deg)" : "rotate(0deg)" }}
        >
          ⌄
        </span>
      </button>
      {open && <div className="tours-acc-body">{children}</div>}
    </div>
  );
}

export default function Tours() {
  const [open, setOpen] = useState({
    incluye: true,
    recomendaciones: false,
    agenda: false,
  });

  const toggle = (key) => setOpen((s) => ({ ...s, [key]: !s[key] }));

  const scrollTo = (id) => (e) => {
    e.preventDefault();
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  const mailtoHref = buildMailto();

  return (
    <div className="tours-page">
      {/* NAV */}
      <div className="tours-nav">
        <div className="tours-nav-brand">
          CLADE 2026 <span>· Experiencia Antigua</span>
        </div>
        <a className="tours-btn" href="#tours-reserva" onClick={scrollTo("tours-reserva")}>
          Reserva aquí
        </a>
      </div>

      {/* HERO */}
      <div className="tours-hero">
        <img className="tours-hero-img" src="/tours/hero.jpg" alt="Tour Antigua Guatemala 2026" />
        <div className="tours-hero-overlay"></div>
        <div className="tours-hero-content">
          <div className="tours-hero-date">
            <div className="tours-date-badge">
              <span className="tours-date-month">Agosto</span>
              <span className="tours-date-day">22</span>
              <span className="tours-date-year">2026</span>
            </div>
            <div className="tours-hero-date-text">
              <span className="tours-date-weekday">Sábado</span>
              <span className="tours-hero-kicker">CLADE 2026</span>
            </div>
          </div>
          <h1>Descubra la esencia de Guatemala más allá del congreso</h1>
          <p className="tours-hero-text">
            Como parte de CLADE 2026, hemos diseñado una experiencia exclusiva para
            conferencistas, patrocinadores y participantes que deseen descubrir la riqueza
            histórica, cultural y gastronómica de Antigua Guatemala, una de las ciudades
            coloniales más emblemáticas de América Latina.
          </p>
          <div className="tours-hero-actions">
            <a className="tours-btn tours-btn-lg" href="#tours-reserva" onClick={scrollTo("tours-reserva")}>
              Reserva aquí
            </a>
            <a className="tours-btn-outline" href="#tours-detalles" onClick={scrollTo("tours-detalles")}>
              Ver detalles
            </a>
          </div>
        </div>
      </div>

      {/* ABOUT */}
      <div id="tours-detalles" className="tours-about">
        <div>
          <div className="tours-kicker">Antigua Guatemala</div>
          <h2>Historia, cultura y tradición</h2>
          <p>
            Declarada Patrimonio Cultural de la Humanidad por la UNESCO, Antigua Guatemala
            cautiva por su arquitectura colonial, sus calles empedradas y el impresionante
            paisaje conformado por los volcanes de Agua, Fuego y Acatenango.
          </p>
          <p>
            Con una combinación única de historia, gastronomía y espacios para el networking,
            esta experiencia ha sido diseñada para fortalecer conexiones profesionales mientras
            descubre algunos de los lugares más representativos del país.
          </p>
        </div>
        <div>
          <img
            className="tours-about-img"
            src="/tours/street.jpg"
            alt="Calles coloniales de Antigua Guatemala"
          />
        </div>
      </div>

      {/* ACCORDION */}
      <div className="tours-accordion-section">
        <div className="tours-accordion">
          <div className="tours-accordion-header">
            <div className="tours-kicker">Todo lo que necesita saber</div>
            <h2>Itinerario y recomendaciones</h2>
            <div className="tours-date-chip">
              <CalendarIcon />
              Sábado 22 de agosto de 2026
            </div>
          </div>

          <AccordionItem
            title="Qué incluye"
            open={open.incluye}
            onToggle={() => toggle("incluye")}
          >
            <p>
              Una experiencia cultural y gastronómica en uno de los destinos más emblemáticos
              de Guatemala.
            </p>
            <ul>
              <li>Transporte ida y vuelta desde el Hotel Barceló hacia Antigua Guatemala.</li>
              <li>
                Recorrido guiado por el Centro Histórico de Antigua Guatemala o ascenso al
                Cerro de la Cruz.
              </li>
              <li>Visita exclusiva a la Jade Maya.</li>
              <li>Traslado a Finca San Cayetano Hotel &amp; Restaurante.</li>
              <li>Almuerzo en Finca San Cayetano Hotel &amp; Restaurante.</li>
            </ul>
            <p className="tours-acc-note">
              Nota: El tour no incluye servicios, consumos o actividades adicionales que no
              estén expresamente indicados en el itinerario oficial.
            </p>
          </AccordionItem>

          <AccordionItem
            title="Recomendaciones"
            open={open.recomendaciones}
            onToggle={() => toggle("recomendaciones")}
          >
            <p>Para disfrutar plenamente de esta experiencia, recomendamos llevar:</p>
            <ul className="tours-recs-list">
              <li>Documento de identificación personal.</li>
              <li>Dinero en efectivo y/o tarjeta para gastos personales.</li>
              <li>Teléfono móvil o cámara fotográfica.</li>
              <li>Calzado cómodo para caminar.</li>
              <li>Ropa ligera y cómoda.</li>
              <li>Gafas de sol, gorra o sombrero.</li>
              <li>Protector solar.</li>
              <li>Chaqueta ligera o impermeable, ya que el clima puede variar.</li>
              <li>Botella de agua reutilizable.</li>
            </ul>
            <p className="tours-acc-strong">Importante:</p>
            <ul>
              <li>Se recomienda llegar puntualmente al punto de salida.</li>
              <li>
                Mantener sus pertenencias personales bajo resguardo durante todo el recorrido.
              </li>
              <li>Seguir las indicaciones del personal organizador y del guía turístico.</li>
            </ul>
          </AccordionItem>

          <AccordionItem
            title="Agenda"
            open={open.agenda}
            onToggle={() => toggle("agenda")}
          >
            <div className="tours-agenda">
              <div className="tours-agenda-date">
                <CalendarIcon size={16} />
                Sábado 22 de agosto de 2026
              </div>
              <div className="tours-agenda-head">
                <div>Horario</div>
                <div>Actividad</div>
              </div>
              {agendaItems.map((row, i) => (
                <div
                  key={row.horario}
                  className="tours-agenda-row"
                  style={{ background: i % 2 === 0 ? "#FBF6EC" : "#F5EBD8" }}
                >
                  <div className="tours-agenda-horario">{row.horario}</div>
                  <div className="tours-agenda-actividad">{row.actividad}</div>
                </div>
              ))}
            </div>
          </AccordionItem>
        </div>
      </div>

      {/* DESTINATIONS */}
      <div className="tours-destinations-section">
        <div className="tours-destinations">
          <div className="tours-destinations-header">
            <div className="tours-kicker">El recorrido</div>
            <h2>Lugares que visitará</h2>
          </div>
          <div className="tours-dest-grid">
            {destinations.map((dest) => (
              <div key={dest.title} className="tours-dest-card">
                <div className="tours-dest-img-wrap">
                  <img src={dest.img} alt={dest.title} loading="lazy" />
                </div>
                <div className="tours-dest-body">
                  <h3>{dest.title}</h3>
                  <p>{dest.desc}</p>
                  <a
                    className="tours-dest-link"
                    href={dest.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    Más información →
                  </a>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* INFO + RESERVA */}
      <div id="tours-reserva" className="tours-reserva">
        <img className="tours-reserva-bg" src="/tours/aerial.jpg" alt="" />
        <div className="tours-reserva-overlay"></div>
        <div className="tours-reserva-grid">
          <div>
            <div className="tours-reserva-kicker">Información importante</div>
            <ul className="tours-reserva-list">
              <li>Tour exclusivo para participantes de CLADE 2026.</li>
              <li>Los espacios son limitados.</li>
              <li>Fecha límite para confirmar asistencia: 31 de julio de 2026.</li>
              <li>Se recomienda utilizar calzado cómodo y protector solar.</li>
            </ul>
            <div className="tours-reserva-datos">
              <div>
                <div className="tours-reserva-label">Costo</div>
                <div className="tours-reserva-costo">
                  US$100 <span>IVA incluido</span>
                </div>
              </div>
              <div>
                <div className="tours-reserva-label">Más información</div>
                <div className="tours-reserva-contacto">Sonia Girón</div>
                <a className="tours-reserva-email" href="mailto:sgiron@ebg.edu.gt">
                  sgiron@ebg.edu.gt
                </a>
              </div>
            </div>
          </div>
          <div className="tours-reserva-card">
            <h3>Reserve su espacio</h3>
            <p>
              El botón enviará un correo pre-completado a Sonia Girón con la información
              necesaria para confirmar su inscripción.
            </p>
            <a className="tours-btn" href={mailtoHref}>
              Reserva aquí
            </a>
            <p className="tours-reserva-nota">Complete asunto y datos antes de enviar.</p>
          </div>
        </div>
      </div>

      {/* FOOTER */}
      <div className="tours-footer">
        Experiencia Antigua Guatemala · CLADE 2026 · Sábado 22 de agosto
      </div>
    </div>
  );
}
